import React, { useState, useEffect } from 'react'; 
import { getFunctions, httpsCallable } from "firebase/functions";
import '../SpectralLibrary.css'
import { app, fbStorage } from '../../firebase/firebase';
import { uploadBytes, ref, deleteObject, getMetadata, updateMetadata } from 'firebase/storage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PolymerListInput from '../spectralLibraryHomePage/components/PolymerListInput/PolymerListInput';
import InstrumentListInput from '../spectralLibraryHomePage/components/InstrumentListInput/InstrumentListInput';
import InstrumentVariedInput from '../spectralLibraryHomePage/components/InstrumentVariedInput/InstrumentVariedInput';
import Navigation from '../../Components/Functionality/navigation/Navigation';
import PlotData from '../spectralLibraryHomePage/components/SpectralPlotter/PlotData';
import MetaData from '../spectralLibraryHomePage/components/MetaData/MetaData';
import { userAuth } from '../../firebase/firebase';
import '../../App.css'
import Button from '../../Components/Functionality/buttons/Buttons';
import { onAuthStateChanged } from 'firebase/auth';
import { useGA4React } from 'ga-4-react';

export const UploaderHomePage = () => {
    const [inputs, setInputs] = useState({ input1: "", input2: "", input3: "" });
    const [currentStep, setCurrentStep] = useState(1);
    const [showRightColumn, setShowRightColumn] = useState(false);
    const [selectedInstrument, setSelectedInstrument] = useState('');
    const [selectedMetaDropName, setSelectedMetaDropName] = useState('');
    const [metadataFields, setMetadataFields] = useState({
      inputOneValue: '',
      inputTwoValue: '',
      inputThreeValue: '',
      inputFourValue: '',
    });
    const [startPoint, setStartPoint] = useState('');
    const [endPoint, setEndPoint] = useState('');
    const [fileCode, setFileCode] = useState('');
    const [fileUrl, setFileUrl] = useState('');
    const [selectedPolymer, setSelectedPolymer] = useState('');
    const [variableInputValue, setVariableInputValue] = useState('');
    const [variableTwoInputValue, setVariableTwoInputValue] = useState('');
    const [userInfo, setUserInfo] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState('');
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
    const [isUploading, setIsUploading] = useState(false);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const functions = getFunctions(app);
    const ga4 = useGA4React();

    const trackPageView = () => {
      if (ga4) {
      ga4.event("page_view", {
        page_title: "Upload Spectra",
        page_location: window.location.href,
        user_id: userAuth.currentUser?.uid || 'anonymous',
        user_email: userAuth.currentUser?.email || 'anonymous'
      });
    }
    };
    
    // File upload attempt tracking
    const trackFileUploadAttempt = (fileName, fileSize, fileType) => {
      if (ga4) {
      ga4.event("file_upload_attempt", {
        file_name: fileName,
        file_size_kb: Math.round(fileSize / 1024),
        file_type: fileType,
        user_id: userAuth.currentUser?.uid || 'anonymous',
        timestamp: new Date().toISOString()
      });
    }
    };
    
    // File upload success tracking
    const trackFileUploadSuccess = (fileName, fileCode, instrument, polymer, processingTime) => {
      if (ga4) {
      ga4.event("file_upload_success", {
        file_name: fileName,
        file_code: fileCode,
        instrument_type: instrument,
        polymer_type: polymer,
        processing_time_ms: processingTime,
        user_id: userAuth.currentUser?.uid || 'anonymous',
        upload_timestamp: new Date().toISOString()
      });
    }
    };
    
    // File upload error tracking
    const trackFileUploadError = (errorMessage, fileName, stage) => {
      if (ga4) {
      ga4.event("file_upload_error", {
        error_message: errorMessage,
        file_name: fileName || 'unknown',
        error_stage: stage, // 'validation', 'upload', 'processing'
        user_id: userAuth.currentUser?.uid || 'anonymous',
        timestamp: new Date().toISOString()
      });
    }
    };
    
    // Device/responsive design tracking
    const trackDeviceUsage = (deviceType, windowWidth) => {
      if (ga4) {
      ga4.event("device_usage", {
        device_type: deviceType, // 'mobile', 'tablet', 'desktop'
        window_width: windowWidth,
        user_agent: navigator.userAgent,
        user_id: userAuth.currentUser?.uid || 'anonymous'
      });
    }
    };
    
    // Performance tracking
    const trackPerformanceMetrics = (uploadStartTime, uploadEndTime, fileSize) => {
      if (ga4) {
      ga4.event("upload_performance", {
        upload_duration_ms: uploadEndTime - uploadStartTime,
        upload_speed_kbps: Math.round((fileSize / 1024) / ((uploadEndTime - uploadStartTime) / 1000)),
        file_size_kb: Math.round(fileSize / 1024),
        user_id: userAuth.currentUser?.uid || 'anonymous'
      });
    }
    };

    useEffect(() => {
      trackPageView();
      trackDeviceUsage(isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop', windowWidth);
    }, []);
    // Track window size for responsive design
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(userAuth, (user) => {
        setIsUserLoggedIn(!!user);
      });
      
      return () => unsubscribe(); // Cleanup subscription
    }, []);

    // Determine if we're on mobile/tablet
    const isMobile = windowWidth < 768;
    const isTablet = windowWidth >= 768 && windowWidth < 1024;
    const isDesktop = windowWidth >= 1024;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prevState) => ({ ...prevState, [name]: value }));
    };
    
  const handlePolymerNameChange = (value) => {
    setSelectedPolymer(value);
  };

  const handleInstrumentNameChange = (value) => {
    setSelectedInstrument(value);
  };
  
  const handleMetaDropNameChange = (value) => {
    setSelectedMetaDropName(value);
  };

  function generateRandomFileCode(length) {
    let charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let code = '';
  
    for (let i = 0; i < length; i++) {
      let randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  const handleInputTwoChange = (value) => {
    setVariableInputValue(value);
  };
  
  // File validation function
  const validateFile = (file) => {
    // Allowed file types for spectral data
    const allowedTypes = [
      'text/csv', 
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/plain',
      'chemical/x-jcamp-dx',  // JCAMP-DX spectral data format
      'application/octet-stream' // Generic binary format (some spectra files)
    ];

    // Check file type
    if (!allowedTypes.includes(file.type) && 
        !file.name.endsWith('.csv') && 
        !file.name.endsWith('.txt') && 
        !file.name.endsWith('.jdx') && 
        !file.name.endsWith('.dx') && 
        !file.name.endsWith('.spc')) {
      return {
        valid: false,
        error: "Invalid file type. Please upload CSV, TXT, or spectral data files."
      };
    }

    // Check file size (10MB max)
    if (file.size > 10 * 1024 * 1024) {
      return {
        valid: false,
        error: "File size exceeds 10MB limit."
      };
    }

    // Check for potentially malicious files
    if (file.name.endsWith('.exe') || 
        file.name.endsWith('.php') || 
        file.name.endsWith('.js') || 
        file.name.endsWith('.html') ||
        file.name.endsWith('.bat') ||
        file.name.endsWith('.sh')) {
      return {
        valid: false,
        error: "Potentially harmful file type detected."
      };
    }

    return { valid: true, error: "" };
  };
    
  const handleFile = (e) => {
    setFileError('');
    if (e.target.files[0]) {
      const file = e.target.files[0];
      
      // Validate file
      const validation = validateFile(file);
      if (!validation.valid) {
        setFileError(validation.error);
        setSelectedFile(null);
        return;
      }
      
      setSelectedFile(file);
    }
  };
  
  const handleMetadataInputChange = (fieldName, value) => {
    // Sanitize input to prevent XSS
    const sanitizeInput = (input) => {
      if (typeof input !== 'string') return input;
      return input
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;')
        .replace(/\//g, '&#x2F;');
    };

    setMetadataFields({
      inputOneValue: sanitizeInput(fieldName.inputOneValue),
      inputTwoValue: sanitizeInput(fieldName.inputTwoValue),
      inputThreeValue: sanitizeInput(fieldName.inputThreeValue),
      inputFourValue: sanitizeInput(fieldName.inputFourValue),
    });
  };
    
  const handleUpload = async () => {
    const uploadStartTime = Date.now();
    trackFileUploadAttempt(selectedFile.name, selectedFile.size, selectedFile.type);
    if (!userAuth.currentUser) {
      toast.error('You must be logged in to upload files', {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (
      selectedFile && selectedInstrument && selectedPolymer && 
      variableInputValue && selectedMetaDropName
    ) {
      // Re-validate the file for security
      const validation = validateFile(selectedFile);
      if (!validation.valid) {
        setFileError(validation.error);
        return;
      }

      setIsUploading(true);
      
      try {    
        let fileCode = generateRandomFileCode(8);
        setFileCode(fileCode); 
        const storageRef = ref(fbStorage, `${selectedInstrument}/tempFolder/${fileCode}`);
        
        await uploadBytes(storageRef, selectedFile);
        setShowRightColumn(true); 
        
        // Call Cloud Function to process the file
        const instance = httpsCallable(functions, 'data_upload_and_storage');
        const result = await instance({ 
          fileName: fileCode,
          instrument: selectedInstrument,
          variable: variableInputValue,
          polymer: selectedPolymer,
        });
        
        setFileUrl(result.data.save_path);
        await uploadBytes(storageRef, selectedFile);
        const deleteRef = ref(fbStorage,`${selectedInstrument}/tempFolder/${fileCode}`);
        
        deleteObject(deleteRef).catch((error) => {
          console.error("Error deleting temporary file:", error);
        });
        
        const fileRef = ref(fbStorage, `${result.data.save_path}`);
        setStartPoint(result.data.start_point);
        setEndPoint(result.data.end_point);
        setUserInfo(userAuth.currentUser.email);
        
        // Sanitize metadata fields one more time before storing
        const sanitizedMetadata = {
          customMetadata: {
            'start_point': `${result.data.start_point}`,
            'end_point': `${result.data.end_point}`,
            'type': `${selectedMetaDropName}`,
            'source': `${metadataFields.inputOneValue}`, 
            'colour': `${metadataFields.inputTwoValue}`, 
            'associatedPublication': `${metadataFields.inputThreeValue}`, 
            'description': `${metadataFields.inputFourValue}`, 
            'uploadedBy': `${userAuth.currentUser.email}`,
            'uploadTimestamp': `${new Date().toISOString()}`
          }
        };
        
        await updateMetadata(fileRef, sanitizedMetadata);
        
        toast.success('Spectra uploaded successfully!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
          style: {
            color: '#282c34',
          },
          progressStyle: {
            background: '#282c34',
          },
        });
        const uploadEndTime = Date.now();
        trackFileUploadSuccess(selectedFile.name, fileCode, selectedInstrument, selectedPolymer, uploadEndTime - uploadStartTime);
        trackPerformanceMetrics(uploadStartTime, uploadEndTime, selectedFile.size);

      } catch (error) {
        console.error('Error sending file for preprocessing:', error);
        toast.error('Upload failed. Please try again.', {
          position: toast.POSITION.TOP_CENTER,
        });
        trackFileUploadError(error.message, selectedFile.name, 'upload');
      } finally {
        setIsUploading(false);
      }
    } else {
      toast.warning('Please ensure you have filled out all available fields!', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: isDesktop ? '400px 1fr' : '1fr',
      gridTemplateRows: !isDesktop && showRightColumn ? 'auto auto' : 'auto',
      gap: isTablet ? '16px' : '24px',
      padding: isTablet ? '16px' : '20px',
      height: 'auto',
      maxWidth: '100%',
      overflowX: 'visible',
      minWidth: 0
    },
    bentoBox: {
      background: 'white',
      borderRadius: '8px',
      padding: isTablet ? '16px' : isMobile ? '12px' : '20px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    },
    bentoBoxSecondColumn: {
      background: 'white',
      borderRadius: '8px',
      padding: isTablet ? '16px' : isMobile ? '12px' : '20px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      width: '100%',
      maxWidth: '100%',
      position: 'relative',
      overflowX: 'auto',
      overflowY: 'hidden',
      minHeight: '250px',
      WebkitOverflowScrolling: 'touch',
      minWidth: 0
    },
    boxTitle: {
      fontSize: isTablet ? '15px' : '16px',
      marginBottom: isTablet ? '12px' : '16px',
      color: '#1a1a1a',
      fontWeight: '600'
    },
    headerFlex: {
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom: isTablet ? '12px' : '16px',
      flexWrap: isTablet ? 'wrap' : 'nowrap',
      gap: isTablet ? '8px' : '0',
    },
    description: {
      fontSize: isTablet ? '13px' : '14px',
      color: '#666',
      lineHeight: '1.5',
      marginBottom: isTablet ? '16px' : '20px'
    },
    progressContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: isMobile ? '24px' : '32px',
      position: 'relative',
      padding: '20px 0'
    },
    progressLine: {
      position: 'absolute',
      top: isMobile ? '14px' : '40px',
      left: isMobile ? '60px' : '80px',
      right: isMobile ? '60px' : '80px',
      height: '2px',
      backgroundColor: '#E5E7EB',
      zIndex: 0
    },
    progressComplete: {
      position: 'absolute',
      top: isMobile ? '14px' : '40px',
      left: isMobile ? '60px' : '80px',
      height: '2px',
      backgroundColor: 'rgb(17, 29, 74)', // Updated to match analyze tab
      zIndex: 1,
      transition: 'width 0.3s ease',
      width: currentStep === 1 ? '0%' : 'calc(100% - 180px)',
      right: isMobile ? '60px' : '80px'
    },
    stepIndicator: (step) => ({
      width: isMobile ? '32px' : '36px',
      height: isMobile ? '32px' : '36px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: currentStep >= step ? 'rgb(17, 29, 74)' : 'white', // Updated to match analyze tab
      border: `2px solid ${currentStep >= step ? 'rgb(17, 29, 74)' : '#E5E7EB'}`,
      color: currentStep >= step ? 'white' : '#6B7280',
      fontWeight: '600',
      zIndex: 2,
      transition: 'all 0.3s ease',
      fontSize: isMobile ? '14px' : '16px'
    }),
    inputLabel: {
      fontSize: '14px',
      color: 'rgb(55, 65, 81)',
      marginBottom: '12px',
      display: 'block',
    },
    stepWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1
    },
    stepLabel: (step) => ({
      marginTop: '12px',
      fontSize: isMobile ? '13px' : '14px',
      color: currentStep >= step ? '#1a1a1a' : '#6B7280',
      fontWeight: currentStep >= step ? '500' : '400',
      textAlign: 'center'
    }),
    formGroup: {
      marginBottom: '16px'
    },
    formLabel: {
      display: 'block',
      marginBottom: '8px',
      color: '#444',
      fontSize: isTablet ? '13px' : '14px',
      fontWeight: '500'
    },
    inputSection: {
      borderBottom: '1px solid #E5E7EB',
      marginBottom: isTablet ? '12px' : '16px',
      paddingBottom: isTablet ? '12px' : '16px'
    },
    selectedDisplay: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: isTablet ? '8px 0' : '12px 0',
      color: '#374151',
      fontSize: isTablet ? '13px' : '14px',
      width: '95%'
    },
    uploadBox: {
      border: '2px dashed #E5E7EB',
      borderRadius: '8px',
      padding: isTablet ? '20px' : '24px',
      textAlign: 'center',
      marginTop: '12px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: '#f9fafb'
    },
    uploadBoxActive: {
      borderColor: 'rgb(17, 29, 74)',
      backgroundColor: '#f8fafc'
    },
    selectedFileInfo: {
      marginTop: '12px',
      padding: '12px',
      backgroundColor: '#f0f7ff',
      borderRadius: '6px',
      fontSize: isTablet ? '13px' : '14px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: '1px solid #e0e7ff'
    },
    fileNameText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '200px',
      fontWeight: '500'
    },
    navigationButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: isTablet ? '8px' : '12px',
      marginTop: '24px',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      width: '100%'
    },
    primaryButton: {
      padding: isTablet ? '8px 16px' : '10px 20px',
      backgroundColor: 'rgb(17, 29, 74)', // Updated to match analyze tab
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: isTablet ? '13px' : '14px',
      opacity: isUploading ? 0.7 : 1,
      transition: 'all 0.2s ease'
    },
    secondaryButton: {
      padding: isTablet ? '8px 16px' : '10px 20px',
      backgroundColor: 'white',
      color: 'rgb(17, 29, 74)', // Updated to match analyze tab
      border: '1px solid rgb(17, 29, 74)',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
      marginRight: isTablet ? '8px' : '12px',
      fontSize: isTablet ? '13px' : '14px',
      transition: 'all 0.2s ease'
    },
    errorText: {
      color: '#EF4444',
      fontSize: isTablet ? '13px' : '14px',
      marginTop: '8px',
      padding: '8px 12px',
      backgroundColor: '#fef2f2',
      borderRadius: '4px',
      border: '1px solid #fecaca'
    },
    sectionTitle: {
      fontSize: isTablet ? '15px' : '16px',
      fontWeight: '600',
      color: '#1a1a1a',
      marginBottom: '16px',
      marginTop: '24px'
    },
    successBanner: {
      padding: '12px 16px',
      backgroundColor: '#f0f9ff', 
      borderRadius: '6px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: isTablet ? '13px' : '14px',
      border: '1px solid #e0f2fe'
    },
    divider: {
      height: '1px',
      backgroundColor: '#E5E7EB',
      margin: isTablet ? '12px 0' : '16px 0'
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div>
            <div style={styles.inputSection}>
              <label style={styles.inputLabel}>Instrument Type</label>
              <InstrumentListInput onChange={value => setSelectedInstrument(value)} />
              {selectedInstrument && (
                <div style={styles.selectedDisplay}>
                  <span>Selected</span>
                  <span>{selectedInstrument}</span>
                </div>
              )}
            </div>
            
            {selectedInstrument && (
              <div style={styles.inputSection}>
                <label style={styles.inputLabel}>Spectral Range</label>
                <InstrumentVariedInput 
                  instrumentType={selectedInstrument} 
                  onChange={value => setVariableInputValue(value)} 
                />
                {variableInputValue && (
                  <div style={styles.selectedDisplay}>
                    <span>Selected</span>
                    <span>{variableInputValue}</span>
                  </div>
                )}
              </div>
            )}
            
            <div style={styles.inputSection}>
              <label style={styles.inputLabel}>Polymer Type</label>
              <PolymerListInput onChange={value => setSelectedPolymer(value)} />
              {selectedPolymer && (
                <div style={styles.selectedDisplay}>
                  <span>Selected</span>
                  <span>{selectedPolymer}</span>
                </div>
              )}
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <h3 style={styles.sectionTitle}>Sample Metadata</h3>
            <MetaData 
              onChange={handleMetaDropNameChange} 
              onInputChange={handleMetadataInputChange}
            />
            
            <h3 style={styles.sectionTitle}>Upload File</h3>
            <div 
              style={{
                ...styles.uploadBox,
                borderColor: fileError ? '#EF4444' : '#E5E7EB',
                background: selectedFile ? '#F9FAFB' : 'white'
              }}
              onClick={() => document.getElementById('file-upload').click()}
            >
              <input 
                type="file" 
                onChange={handleFile}
                style={{ display: 'none' }}
                id="file-upload"
                accept=".csv,.txt,.jdx,.dx,.spc"
              />
              {!selectedFile ? (
                <div>
                  <p>Click or drag file to upload</p>
                  <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '8px' }}>
                    Supported formats: CSV, TXT, JDX, DX, SPC
                  </p>
                </div>
              ) : (
                <div style={styles.selectedFileInfo}>
                  <span style={styles.fileNameText}>{selectedFile.name}</span>
                  <span>{(selectedFile.size / 1024).toFixed(1)} KB</span>
                </div>
              )}
            </div>
            {fileError && <p style={styles.errorText}>{fileError}</p>}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div style={styles.container}>
    {/* Left Column */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: isTablet ? '16px' : '24px' }}>
      <div style={styles.bentoBox}>
        <div style={styles.headerFlex}>
          <h1 style={styles.boxTitle}>Upload Spectra</h1>
        </div>
        
        <p style={styles.description}>
          Upload your spectral data to contribute to our polymer identification library.
        </p>
        
        <div style={styles.progressContainer}>
          <div style={styles.progressLine} />
          <div style={styles.progressComplete} />
          
          <div style={styles.stepWrapper}>
            <div style={styles.stepIndicator(1)}>1</div>
            <span style={styles.stepLabel(1)}>Instrument & Polymer</span>
          </div>
          
          <div style={styles.stepWrapper}>
            <div style={styles.stepIndicator(2)}>2</div>
            <span style={styles.stepLabel(2)}>Metadata & File</span>
          </div>
        </div>

        {renderStepContent()}

        <div style={styles.navigationButtons}>
          {currentStep > 1 && (
            <Button 
              type='secondary'
              onClick={() => setCurrentStep(prev => prev - 1)}
              disabled={isUploading}
            >
              Previous
            </Button>
          )}
          {currentStep < 2 ? (
            <Button 
              type='primary'
              onClick={() => setCurrentStep(prev => prev + 1)}
              disabled={!selectedInstrument || !selectedPolymer || !variableInputValue}
            >
              Next
            </Button>
          ) : (
            <Button 
              type={!isUserLoggedIn ? 'login' : 'primary'}
              onClick={isUserLoggedIn ? handleUpload : () => {
                toast.info('Please log in to upload your spectra', {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                });
                // Optionally redirect to login page
                // navigate('/sign-in');
              }}
              disabled={isUserLoggedIn ? (!selectedFile || !selectedMetaDropName || isUploading) : false}
            >
              {isUploading ? 'Uploading...' : 
              !isUserLoggedIn ? 'Log In to Upload' : 'Upload'}
            </Button>
          )}
        </div>
      </div>
    </div>

    {/* Right Column - Results */}
    {showRightColumn && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: isTablet ? '16px' : '24px' }}>
        <div style={styles.bentoBoxSecondColumn}>
          <div style={styles.headerFlex}>
            <h2 style={styles.boxTitle}>
              {selectedPolymer}'s {
                selectedInstrument === "Raman Microscopy" 
                  ? "Raman" 
                  : selectedInstrument === "Fourier Transform Infrared Spectroscopy" 
                    ? "FTIR" 
                    : selectedInstrument
              } spectrum
            </h2>
          </div>
          
          {isUploading && (
            <div style={styles.successBanner}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 6v6l4 2"></path>
              </svg>
              <div>
                <strong>Upload in progress...</strong> Your spectrum is being processed and will appear below when complete.
              </div>
            </div>
          )}
          
          <div style={styles.divider} />
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <PlotData
              url={fileUrl}
              pageName={'Uploader'}
              polymer={selectedPolymer}
              instrument={selectedInstrument}
            />
          </div>
        </div>
      </div>
    )}
    <ToastContainer />
  </div>
  );
};

export default UploaderHomePage;